import { render } from "./About.vue?vue&type=template&id=59d8e70b"
const script = {}

import exportComponent from "/Users/patrikhubner/Dropbox/htdocs/netartmarathon/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__